import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import config from 'config/default.json';
import { DialogComponent } from 'src/app/back-office/components/dialog/dialog.component';
import { FloatWindowComponent } from 'src/app/back-office/components/float-window/float-window.component';
declare const DocsAPI: any;
@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss']
})
export class DocumentationComponent {
  constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,) {
  }
  @Input() userInfos: { [x:string]: any } = new Map();
  editConfig:any;
  toEdit:boolean = false;
  editor: any;
  service: string = '';
  ngOnInit(): void {
    
  }
  launchService(serviceKey: string){
    this.service = serviceKey;
    if(serviceKey == 'content-presentation') this.playLeaning('https://ndapi.master.enovsky.com/formation_module_1.mp4');
    if(serviceKey == 'content-upload') this.playLeaning('https://ndapi.master.enovsky.com/formation_module_2.mp4');
    if(serviceKey == 'content-splitting') this.playLeaning('https://ndapi.master.enovsky.com/formation_module_3.mp4');
    if(serviceKey == 'content-edition') this.playLeaning('https://ndapi.master.enovsky.com/formation_module_4.mp4');
    if(serviceKey == 'chemistry-formular') this.playLeaning('https://ndapi.master.enovsky.com/build-chemistry-formular.mp4');
    
    
    if(serviceKey == 'content-documentation') this.showContent({
      docx_file: config.master.ndapi.url + '/content_integration.docx',
      file_urls: [{id_content: 0, url: config.master.ndapi.url + '/content_integration.pdf'}],
      show_mode: 'pdf-show',
      page_origin: 'show-editor-pdf'
    });
    if(serviceKey == 'content-templates') this.showContent({
      docx_file: config.master.ndapi.url + '/content_templates.docx',
      file_urls: [{id_content: 1, url: config.master.ndapi.url + '/content_templates.pdf'}],
      show_mode: 'docx-edit',
      page_origin: 'show-editor-docx'
    })
    this.cdRef.detectChanges();

  }
  showContent(data: any){
    const dialogRef = this.dialog.open(FloatWindowComponent, {
      maxWidth: '100vw',
            height: '100%',
            width: '100%',
            panelClass: 'full-screen-modal',
      position: {top: '30px' },
      data: {action: 'show-content', source: 'master', page_origin: data.page_origin, show_mode: data.show_mode, file_urls: data.file_urls, docx_file: data.docx_file, user_infos: this.userInfos}
    });
  
    dialogRef.afterClosed().subscribe((toContinue:boolean) => {
      if(toContinue){
        
      }
    });
  }
  playLeaning(url:string){
    const dialogRef = this.dialog.open(DialogComponent, {
      //width: '70%',
      position: {top: '30px' },
      data: {page: 'video_show', title: 'Learning Edit Content', url: url}
    });
    dialogRef.afterClosed().subscribe((toContinue:boolean) => {
      if(toContinue){
        
      }
    });
  }
}
